import { createContext } from 'react';
import { KeycloakInitOptions, KeycloakLogoutOptions } from 'keycloak-js';

export interface IKeycloak {
  realm?: string;
  token?: string;
  subject?: string;
  loadUserProfile(): Promise<any>;
  idTokenParsed?: {
    name: string;
    locale: string;
    cpfCnpj: string;
    customerId: number;
    customerType: string;
    customerIds?: Array<number>;
    preferred_username?: string;
    sub: string;
    given_name?: string;
    family_name?: string;
  };
  resourceAccess?: {
    portal: {
      roles: string[];
    };
  };
  init(initOptions: KeycloakInitOptions): Promise<boolean>;
  updateToken(minValidity: number): Promise<boolean>;
  logout(logoutParams?: KeycloakLogoutOptions): {};
  sessionId?: string;
  authenticated?: boolean;
}

const initialValues = {
  keycloak: {} as IKeycloak,
};

export default createContext(initialValues);
